module.exports = __webpack_public_path__ + "static/media/podcast200x200.768e6ae3.jpg";